import { gql } from "@urql/svelte";

export const ClickStoryApi = gql`
    query clickStoryQuery($clickStoryId: Int) {
        clickStory(clickStoryId: $clickStoryId) {
            id
            text
            copyright
            imageSrc
        }
    }
`;
